export default "__VITE_ASSET__jOMhrXba__"